module.exports = __webpack_public_path__ + "static/img/02best.ef8561d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/dark/sport/07sportIndex/02best.png
// module id = c1sp
// module chunks = 0